import React, { Component } from 'react';
import {ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'
import moment from 'moment'

import SelectMainProduct from './SelectMainProduct'
import SelectBendedProduct from './SelectBendedProduct'
import SelectMiscellaneousProduct from './SelectMiscellaneousProduct'
import SelectHardwareProduct from './SelectHardwareProduct'

import QMainProductEdit from './QMainProductEdit'
import QBendedEdit from './QBendedEdit'
import QHardwareEdit from './QHardwareEdit'
import QMiscellaneousEdit from './QMiscellaneousEdit'

class Deal extends Component {

    constructor(){
        super();

        this.getTotal = this.getTotal.bind(this);
        this.getTotal2 = this.getTotal2.bind(this);
        this.handleDelivery = this.handleDelivery.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setItem =this.setItem.bind(this)
        this.setThickness =this.setThickness.bind(this)
        this.removeTotal = this.removeTotal.bind(this)
        this.removeTotal2 = this.removeTotal2.bind(this)
        this.handleCustomerName = this.handleCustomerName.bind(this)
        this.handleContactNumber = this.handleContactNumber.bind(this)
        this.handleProject = this.handleProject.bind(this)
        this.handleLocation = this.handleLocation.bind(this)
        this.handleReference = this.handleReference.bind(this)
        this.handleSched = this.handleSched.bind(this)
        this.handleEta = this.handleEta.bind(this)
        this.state={
            total : {},
            total2 : {},
            totalValue : 0,
            totalValue2 : 0,
            temp : {},
            deliveryCharge : 0,
            customerData : {},
            item : "",
            thickness : "",
            discount : 0,
            customerName : "",
            contactNumber : "",
            project : "",
            reference : "",
            location : "",
            sched : "",
            eta : ""

        }
        
    }

    componentDidMount(){

        
    }

    getTotal(index,data){

        let total = {...this.state.total}
            total[index]={
                data : parseInt(data,10)
            }

            this.setState({
                total
            }) 
        

    }

    getTotal2(index,data){

        let total2 = {...this.state.total2}
            total2[index]={
                data : parseInt(data,10)
            }

            this.setState({
                total2
            })        

    }
    
    removeTotal(index){
        let stateTotal = this.state.total

        delete stateTotal[index]
        
        let ids = Object.keys(this.state.total)
        let total = ids.reduce((prevTotal,key)=>{
            let value = this.state.total[key]
            return prevTotal + value.data
        },0)
        this.setState({
            totalValue :total.toFixed(2)
        })

        this.setState({total : stateTotal})    

    }

     removeTotal2(index){
        let stateTotal = this.state.total2

        delete stateTotal[index]
        
        let ids = Object.keys(this.state.total2)
        let total = ids.reduce((prevTotal,key)=>{
            let value = this.state.total2[key]
            return prevTotal + value.data
        },0)
        this.setState({
            totalValue2 :total.toFixed(2)
        })

        this.setState({total2 : stateTotal})    

    }
    
    
    componentDidUpdate(prevProps,prevState){
        if(prevState.total !== this.state.total){
            let ids = Object.keys(this.state.total)
            let total = ids.reduce((prevTotal,key)=>{
                let value = this.state.total[key]
                return prevTotal + value.data
            },0)
            this.setState({
                totalValue :total.toFixed(2)
            })
            
            if(this.props.quotation.deliveryCharge){
                this.setState({
                    deliveryCharge : parseInt(this.props.quotation.deliveryCharge,10)
                })
            }

            if(this.props.customer.name){
                this.setState({
                    customerName : this.props.customer.name
                })
            }
            if(this.props.customer.number){
                this.setState({
                    contactNumber : this.props.customer.number
                })
            }
            if(this.props.customer.project){
                this.setState({
                    project : this.props.customer.project
                })
            }
            if(this.props.customer.location){
                this.setState({
                    location : this.props.customer.location
                })
            }
            if(this.props.customer.reference){
                this.setState({
                    reference : this.props.customer.reference
                })
            }
            if(this.props.customer.sched){
                this.setState({
                    sched : this.props.customer.sched
                })
            }
            if(this.props.customer.eta){
                this.setState({
                    eta : this.props.customer.eta
                })
            }
        
            //console.log(this.props.quotation.discount)
        }
        if(prevState.total2 !== this.state.total2){
            let ids = Object.keys(this.state.total2)
            let total = ids.reduce((prevTotal,key)=>{
                let value = this.state.total2[key]
                return prevTotal + value.data
            },0)
            //total = total.toFixed(2)
            this.setState({
                totalValue2 :total.toFixed(2)
            })
        }
        
    }

    handleDelivery(e){
        
        let amount = e.target.value
        this.setState({
            deliveryCharge : amount
        })
    }
    handleCustomerName(e){
        
        this.setState({
            customerName : e.target.value
        })
    }
    handleContactNumber(e){
        
        this.setState({
            contactNumber : e.target.value
        })
    }
    handleProject(e){
        
        this.setState({
            project : e.target.value
        })
    }
    handleLocation(e){
        
        this.setState({
            location : e.target.value
        })
    }
    handleReference(e){
        
        this.setState({
            reference : e.target.value
        })
    }
    handleSched(e){
        
        this.setState({
            sched : e.target.value
        })
    }
    handleEta(e){
        
        this.setState({
            eta : e.target.value
        })
    }

    handleSubmit(e){
        e.preventDefault()
        let refer = this.refs
        Object.keys(refer).map((key)=>{
            let temp = this.state.temp
                temp[key] = {
                    productId : refer[key].productId.value,
                    category : refer[key].category.value,
                    productName : refer[key].productName.value,
                    productDimension : refer[key].productDimension.value,
                    productThickness : refer[key].productThickness.value,
                    productNumber : refer[key].productNumber.value,
                    productPrice : refer[key].productPrice.value,
                    productUnit : refer[key].productUnit.value,
                    productDiscount : refer[key].productDiscount.value,
                    productTotal : refer[key].productTotal.value
                }
                this.setState({temp})             
                
        })
          
            let customerData ={
                    name : this.customerName.value,
                    number : this.contactNumber.value,
                    project : this.project.value,
                    reference : this.reference.value,
                    location : this.location.value,
                    representative : this.salesRepName.value,
                    item : this.state.item,
                    thickness : this.state.thickness,
                    sched : this.sched.value,
                    eta : this.eta.value
                }

            let cornersData = {
                    cornerQty : this.props.cornerQty,
                    cornerPrice : this.props.cornerPrice,
                    cornerDis : this.props.cornerDis,
                    cornerTotal : this.props.cornerTotal
            }
            
        let saveData = {
            userId : this.props.quotation.userId,
            quoteDate : this.quoteDate.value,
            quoteNumber : this.quoteNumber.value,
            customer : customerData,
            products : this.state.temp,
            labor : this.props.totalLabor,
            totalValue :this.state.totalValue,
            totalValue2 : this.state.totalValue2,
            laborCost : this.props.totalLaborValue,
            totalMaterials : this.totalMaterials.value,
            totalQuote : this.totalQuote.value,
            deliveryCharge : this.deliveryCharge.value,
            corners : cornersData,
            status : "Approved"
        }
        ref.child("Quotation").child(this.props.quotId).update(saveData).then(alert(" Quotation has been Updated"))
        window.location.assign("/quotation/approved")
    }

    setItem(item){
        this.setState({
            item : item
        })
    }
    setThickness(thick){
        this.setState({
            thickness : thick
        })
    }
    press(e){
         if (e.which === 13 /* Enter */) {
                e.preventDefault();
            }
    }

    render() {
            //var sum = 0
            var totalMaterials = parseInt(this.state.totalValue,10) + parseInt(this.state.totalValue2,10)
            var totalQuote = parseInt(totalMaterials,10) + parseInt(this.state.deliveryCharge,10) 
        return (

            <div >
                    <div >                                                     
                        <form className="form-horizontal form-bordered" onSubmit={this.handleSubmit} onKeyPress={this.press}>
                            <em><p className="text-right getComputerDate">Date: {moment().format("MMMM DD YYYY")}<input type="hidden" ref={ input => this.quoteDate = input } value ={moment().format("MMMM DD YYYY")} /></p></em>
                            <p className="text-right getComputerDate">Quotation Number: <input type="text" ref={ input => this.quoteNumber = input } value={this.props.quotation.quoteNumber} required/></p>
                            <h3 className="text-center paddingLeft20px">Customer Information</h3>
                                <div className="row">    
                                    <div className="form-group col-md-6">
                                        <label className="col-md-5 control-label" >Customer / Company Name</label>
                                        <div className="col-md-6">
                                            <input className="form-control"  ref={ input => this.customerName = input } value={this.state.customerName} onChange={this.handleCustomerName} type="text" required/>
                                        </div>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label className="col-md-3 control-label" >Contact Number</label>
                                        <div className="col-md-6">
                                            <input className="form-control"  ref={ input => this.contactNumber = input } value={this.state.contactNumber} onChange={this.handleContactNumber} type="text" required/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">    
                                    <div className="form-group col-md-6">
                                        <label className="col-md-5 control-label" >Project</label>
                                        <div className="col-md-6">
                                            <input className="form-control"   ref={ input => this.project = input } type="text" value={this.state.project} onChange={this.handleProject} required/>
                                        </div>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label className="col-md-3 control-label" >Reference</label>
                                        <div className="col-md-6">
                                            <select className="form-control text-uppercase" name="length" ref={ input => this.reference=input } value={this.state.reference} onChange={this.handleReference} >
                                                <option>Select Reference</option>
                                                <option value="Actual Measurement">Actual Measurement</option>
                                                <option value="Given Quantity">Given Quantity</option>
                                                <option value="Based on Plan">Based on Plan</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">    
                                    <div className="form-group col-md-6">
                                        <label className="col-md-5 control-label" >Location / Delivery Site</label>
                                        <div className="col-md-6">
                                            <input className="form-control"  ref={ input => this.location = input  } type="text" value={this.state.location} onChange={this.handleLocation} required/>
                                        </div>
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label className="col-md-3 control-label" >Sales Representative</label>
                                        <div className="col-md-6">
                                            <input className="form-control"  ref={ input => this.salesRepName = input } value={this.props.customer.representative} type="text" required/>
                                        </div>
                                    </div>
                                </div>                                                                  
                                
                                <h3 className="text-left paddingLeft20px">Sales Contract</h3>
                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Roof Type</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-left forRoofType">Product Name</th>
                                                <th className="text-left forDimension">Dimension</th>
                                                <th className="text-left forThickness">Thickness</th>
                                                <th className="text-center forLengthSize">Number</th>
                                                <th className="text-center forUnitType">Unit</th>
                                                <th className="text-center forPriceValue">Price</th>
                                                <th className="text-center forUnitDesc">Per Unit</th>
                                                <th className="text-center forAreaValue">Discount</th>
                                                <th className="text-center forAreaValue">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            { 
                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Main Product"){                                                   
                                                            //console.log(list)
                                                            return <QMainProductEdit ref={key} key={key} index={key} product ={list} 
                                                                     setProductsLabor={this.props.setProductsLabor} getTotal={this.getTotal}
                                                                     setItem={this.setItem} setThickness = {this.setThickness} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal} 
                                                                      />                                                    
                                                           }
                                                    }.bind(this))

                                            } 
                                            <SelectMainProduct setList ={this.props.setList}/>                                     
                                        </tbody>
                                    </table>
                                </div>

                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Bended Accessories</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-left forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            {

                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Bended Accessories"){                                                   
                                                            
                                                            return <QBendedEdit ref={key} key={key} index={key} product ={list}  
                                                                    setProductsLabor={this.props.setProductsLabor} getTotal={this.getTotal} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal} />                                                    
                                                           }
                                                    }.bind(this))

                                            }
                                            <SelectBendedProduct setList ={this.props.setList}/>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Subtotal</td>
                                                <td>
                                                    {                                                 
                                                        formatPrice(this.state.totalValue)
                                                    }
                                                </td>
                                            </tr> 
                                                                                                                    
                                        </tbody>
                                    </table>
                                </div>

                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Miscellaneous</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-left forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            {  

                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Miscellaneous"){                                                   
                                                            
                                                            return <QMiscellaneousEdit  ref={key} key={key} index={key} product ={list} getTotal2={this.getTotal2} 
                                                            setProductsLabor={this.props.setProductsLabor} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal2} />                                                    
                                                           }
                                                    }.bind(this))  
                                
                                            } 
                                            <SelectMiscellaneousProduct setList ={this.props.setList}/>                                   
                                        </tbody>
                                    </table>
                                </div>

                                <div className="wrapperTable">
                                    <div className="titleHolderDesc">
                                        <h4 className="paddingLeft20px"><strong>Hardware Accessories</strong></h4>   
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-left forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="forInputArea">
                                            {    
                                                
                                                this.props.productsList &&                                     
                                                    Object.keys(this.props.productsList).map(function (key){
                                                        let list = this.props.productsList[key]
                                                        if(list.category ==="Hardware Accessories"){                                                   
                                                            
                                                            return <QHardwareEdit ref={key} key={key} index={key} product ={list} getTotal2={this.getTotal2} remove = {this.props.remove} 
                                                                      removeTotal={this.removeTotal2} />                                                    
                                                           }
                                                    }.bind(this))

                                            }
                                            <SelectHardwareProduct setList ={this.props.setList}/>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Total</td>
                                                <td>
                                                    {                                                 
                                                        formatPrice(this.state.totalValue2)
                                                    }
                                                </td>
                                            </tr>          
                                        </tbody>                                            
                                    </table>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-left forRoofType"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forLengthSize"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forUnitType"></th>
                                                <th className="text-center forPriceValue"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forUnitDesc"></th>
                                                <th className="text-center forAreaValue"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Total Materials</td>
                                                <td>
                                                    {                                                 
                                                        formatPrice(totalMaterials)
                                                    }
                                                    <input type="hidden" className="form-control" value={totalMaterials.toFixed(2)} name="totalMaterials" ref={input => this.totalMaterials = input}   />
                                                </td>
                                            </tr>                                                
                                            
                                            <tr>
                                                <td><input className="form-control text-uppercase"  ref={ input => this.sched = input }   placeholder="DELIVERY SCHEDULE: (ex. 10 - 15 working days. )" value={this.state.sched} onChange={this.handleSched} /></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>                                                
                                                <td></td>
                                                <td>Delivery Charge</td>
                                                <td>
                                                   <input type="text" className="form-control"  name="deliveryCharge" ref={input => this.deliveryCharge = input} value={this.state.deliveryCharge} onChange={this.handleDelivery} />
                                                </td>                                                
                                            </tr>
                                            <tr className="grandTotalTdRow">
                                                <td><input className="form-control text-uppercase"  ref={ input => this.eta = input }  value={this.state.eta} placeholder="ETA: (ex. around 9:00am)" onChange={this.handleEta} /></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>                                                
                                                <td></td>
                                                <td className="grandTotal">Grand Total</td>
                                                <td className="grandTotal">
                                                    {
                                                        formatPrice(totalQuote)
                                                    }
                                                   <input type="hidden" className="form-control"  name="totalQuote" ref={input => this.totalQuote = input}  value={totalQuote.toFixed(2)} />
                                                    
                                                    
                                                </td>                                                
                                            </tr>                  
                                        </tbody>                                            
                                    </table>
                                </div>
                                <div className="submitContract text-center">
                                   <button type="submit" className="btn btn-lg btn-primary">Update</button>
                                </div>
                           </form> 
                        </div>
                    </div>                    
        );
    }
}

export default Deal;



// WEBPACK FOOTER //
// ./src/components/Deal.js